module.exports = __webpack_public_path__ + "static/media/ArrowUpNew.02710f9a.svg";